import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService } from './../../shared';

@Component({
  selector: 'blog-roll',
  template: require('./blog-roll.component.html'),
  styles: [require('./../blog.component.scss'), require('./blog-roll.component.scss')]
})
export class BlogRollComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService) {
    // Do stuff
  }

  title = 'Ocean Container Shipping Search Engine Blog - Linescape';
  description = 'Get the latest news from Linescape, the first independent liner shipping search engine dedicated to ocean container sailing schedules.';

  ngOnInit() {
      this.seo.set(this.title, this.description);
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/blog-roll/blog-roll.component.ts